import { render } from "./StrokedArrowDownIcon.vue?vue&type=template&id=12137234"
import script from "./StrokedArrowDownIcon.vue?vue&type=script&lang=js"
export * from "./StrokedArrowDownIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__